import React from 'react';
import { Verification } from 'api/verifications/types';
import VerificationHeaderPanel from 'components/Verification/VerificationHeaderPanel';
import MvrMatrixVerificationForm from './MvrMatrixVerificationForm';
import MvrDocumentCollectionInfoHeader from './MvrDocumentCollectionInfoHeader';

interface MvrDocumentCollectionProps {
  readonly verification: Verification;
}

export default function MvrDocumentCollection({
  verification,
}: MvrDocumentCollectionProps) {
  return (
    <div className='matrix-verification-wrapper'>
      <VerificationHeaderPanel {...verification} />
      <MvrDocumentCollectionInfoHeader verification={verification} />
      <MvrMatrixVerificationForm
        company={verification.company}
        fields={verification.fieldConfigurations}
      />
    </div>
  );
}
